import { UserRole } from '@lombok/shared';
import type { UserRole as UserRoleType } from '@lombok/shared';

/** Roles that may approve/reject (mirrors backend APPROVAL_ROLES — UX gate only). */
export const APPROVAL_ROLES: readonly UserRoleType[] = [
  UserRole.SUPER_ADMIN,
  UserRole.ADMIN,
  UserRole.SALES_MANAGER,
];

/** Whether to show approval work (queue, "por aprobar" counts) to this role. */
export function canApproveOrders(role: UserRoleType | undefined): boolean {
  return role !== undefined && APPROVAL_ROLES.includes(role);
}
